module.exports = "/CommentActive@2x-bb5ec6cf456fcb8a5872c5eab98014cb.png";